/* step 13: Bag (cart drawer), phone and desktop. Created by the step 01 gate, Oct 17, 2026. Owner: step 13 only. Guard calls into other steps (if (window.X) ...). */

(function () {
  'use strict';

  var PHONE = '(max-width: 749px)';
  var removing = false;
  var removingTimer = null;
  var toastTimer = null;
  var giftBusy = false;
  var subscribed = false;
  var syncTimer = null;
  var observedDrawer = null;

  function isPhone() {
    try { return window.matchMedia(PHONE).matches; } catch (e) { return false; }
  }

  /* C4: window.pbsToast(text), element #pbs-toast.pbs-toast */
  window.pbsToast = function (text) {
    try {
      var el = document.getElementById('pbs-toast');
      if (!el) {
        el = document.createElement('div');
        el.id = 'pbs-toast';
        el.className = 'pbs-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        (document.body || document.documentElement).appendChild(el);
      }
      el.textContent = text == null ? '' : String(text);
      /* force a reflow so a repeat call restarts the transition cleanly */
      void el.offsetWidth;
      el.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, isPhone() ? 1800 : 3400);
    } catch (e) {}
  };

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* bag-open flag */
  function syncOpen() {
    try {
      var d = getDrawer();
      var on = !!(d && d.classList.contains('active'));
      if (document.body) document.body.classList.toggle('pbs-bag-open', on);
    } catch (e) {}
  }

  /* minus buttons at quantity 1 on phones */
  function syncMinus() {
    try {
      var d = getDrawer();
      if (!d) return;
      var phone = isPhone();
      var btns = d.querySelectorAll('quantity-input .quantity__button[name="minus"]');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var input = b.closest('quantity-input').querySelector('input.quantity__input');
        var min = phone && input && Number(input.value) === 1;
        if (min) {
          b.setAttribute('aria-disabled', 'true');
          b.classList.add('is-min');
        } else {
          b.removeAttribute('aria-disabled');
          b.classList.remove('is-min');
        }
      }
    } catch (e) {}
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncMinus, 60);
  }

  document.addEventListener('click', function (event) {
    try {
      var t = event.target;
      if (!t || !t.closest) return;
      var drawer = t.closest('cart-drawer');
      if (!drawer) return;

      /* phone minus guard */
      var minus = t.closest('.quantity__button[name="minus"]');
      if (minus && isPhone()) {
        var qi = minus.closest('quantity-input');
        var input = qi && qi.querySelector('input.quantity__input');
        if (input && Number(input.value) === 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
      }

      /* remove */
      var rm = t.closest('cart-remove-button .cart-remove-button');
      if (rm) {
        if (isPhone()) {
          var row = rm.closest('tr.cart-item');
          if (row) row.classList.add('pbs-out');
        }
        removing = true;
        clearTimeout(removingTimer);
        removingTimer = setTimeout(function () { removing = false; }, 5000);
        return;
      }
    } catch (e) {}
  }, true);

  /* gift toggle (desktop) */
  document.addEventListener('click', function (event) {
    try {
      var t = event.target;
      if (!t || !t.closest) return;
      var btn = t.closest('button.pbs-gift');
      if (!btn || !btn.closest('cart-drawer')) return;
      if (giftBusy) return;
      var next = btn.getAttribute('aria-checked') !== 'true';
      giftBusy = true;
      btn.setAttribute('aria-checked', next ? 'true' : 'false');
      var url = window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';
      var revert = function () { btn.setAttribute('aria-checked', next ? 'false' : 'true'); };
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { Gift: next ? 'Yes' : '' } })
      }).then(function (res) {
        giftBusy = false;
        if (res && res.ok) {
          window.pbsToast(next ? 'Gift mode on. Ships in a plain mailer.' : 'Gift mode off');
        } else {
          revert();
        }
      }).catch(function () {
        giftBusy = false;
        revert();
      });
    } catch (e) { giftBusy = false; }
  });

  function onCartUpdate(event) {
    try {
      if (removing && event && event.source === 'cart-items') {
        removing = false;
        clearTimeout(removingTimer);
        window.pbsToast('Removed from bag');
      }
      scheduleSync();
    } catch (e) {}
  }

  function trySubscribe() {
    if (subscribed) return;
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
        subscribed = true;
      }
    } catch (e) {}
  }

  function observeDrawer() {
    try {
      var d = getDrawer();
      if (!d || d === observedDrawer || typeof MutationObserver !== 'function') return;
      observedDrawer = d;
      new MutationObserver(syncOpen).observe(d, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(scheduleSync).observe(d, { childList: true, subtree: true });
      syncOpen();
      syncMinus();
    } catch (e) {}
  }

  function init() {
    trySubscribe();
    observeDrawer();
  }

  try {
    window.addEventListener('resize', scheduleSync);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('load', init);
  } catch (e) {}
})();
